import axios from 'axios'

export default {
  namespaced: true,
  state: {
    configuracao: null,
    listaStatus: [],
    statusAtual: null
  },
  actions: {
    fetchConfiguracao({ commit, rootState, dispatch }, idlocalconfig, config) {
      axios
        .get(rootState.baseUrlLocalDeProva + `LocalExameConfig/GetById/${idlocalconfig}`, config)
        .then((response) => {
          commit('SET_CONFIGURACAO', response.data)
          dispatch('fetchListaStatus', idlocalconfig, config)
        })
        .catch(this.setErrorSystem)
    },
    fetchListaStatus({ commit, rootState, state, dispatch }, config) {
      const etapas = [1, 2, 3, 4, 5, 6, 7, 8]

      const promises = etapas.map((etapa) =>
        axios.get(
          rootState.baseUrlLocalDeProva +
            `LocalExameConfig/GetEtapaSituacao/${etapa}/${state.configuracao.idlocalconfig}`,
          config
        )
      )

      return new Promise((resolve, reject) => {
        return Promise.all(promises)
          .then((values) => {
            const lista = values.map((value, index) => ({
              tpEtapa: etapas[index],
              tpSituacao: value.data.tpsituacao
            }))
            commit('SET_LISTA_STATUS', lista)
            dispatch('fetchStatusAtual', config)
            resolve()
          })
          .catch(reject)
      })
    },
    fetchStatusAtual({ commit, rootState, state }, config) {
      return new Promise((resolve, reject) => {
        return axios
          .get(
            rootState.baseUrlLocalDeProva +
              `LocalExameConfig/GetHistoricoLocalExameConfig/${state.configuracao.idlocalconfig}`,
            config
          )
          .then((response) => {
            commit('SET_STATUS_ATUAL', response.data)
            resolve()
          })
          .catch(reject)
      })
    }
  },
  mutations: {
    SET_CONFIGURACAO(state, data) {
      state.configuracao = data
    },
    SET_LISTA_STATUS(state, data) {
      state.listaStatus = data
    },
    SET_STATUS_ATUAL(state, data) {
      state.statusAtual = data
    },
    RESET_STORE(state) {
      state.configuracao = null
      state.statusAtual = null
      state.listaStatus = []
    }
  }
}
